import { render, staticRenderFns } from "./NoticeDetails.vue?vue&type=template&id=39d9128c"
import script from "./NoticeDetails.vue?vue&type=script&lang=js"
export * from "./NoticeDetails.vue?vue&type=script&lang=js"
import style0 from "./NoticeDetails.vue?vue&type=style&index=0&id=39d9128c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports